module.exports = __webpack_public_path__ + "static/woman-trading-b7b2e14ea5c3afa6f5a2aacea2043521.jpg";